<script>
  import { datepicker } from 'vue-strap';

  export default {
    components: { datepicker },
    props: {
      atividade: Object,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        valorMaximo: 0,
      }
    },
    computed: {

    },
    methods: {
      habilitarRPA() {
        if (this.configuracao.valorAtividadeContratoVariavel && this.atividade.contrato.tipoContrato == 2) {
          $('#valorALiberar').prop('disabled', '');
          this.atividade.valorLiberado = "";
        }
      },
      validar() {
        return this.$validator.validateAll();
      },
      desabilitarAnalise(analise) {
        $('.datepicker input').attr('readonly', 'readonly');
        $('.datepicker input').attr('disabled', 'disabled');

        if (this.configuracao.naoEditarDescricaoAtividadeBolsa)
          return true;

        return false;
      },
    },
  }
</script>

<template>
  <div>    
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('dataEntrega')}">

          <label class="control-label">Data entrega</label>

          <datepicker v-model="atividade.dataEntrega"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataEntrega"
                      data-vv-as="data de entrega"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataEntrega')">{{ errors.first('dataEntrega') }}</p>
        </div>
      </div>

      <div class="col-lg-4" v-if="atividade.contrato.tipoContrato == 2 && configuracao.valorAtividadeContratoVariavel">

        <div class="form-group required" :class="{'has-error': errors.has('valorMaximo')}">

          <label class="control-label" for="valorMaximo">Valor atividade (R$)</label>

          <input type="text"
                 class="form-control"
                 id="valorMaximo"
                 v-model="atividade.valorMaximo"
                 data-vv-name="valorMaximo"
                 data-vv-as="valor máximo"
                 v-mascara="'moeda'"
                 v-validate="'required|not_zero'"
                 disabled>

          <p class="text-danger" v-show="errors.has('valorMaximo')">{{ errors.first('valorMaximo') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('valorALiberar')}">
          <label class="control-label" for="valorALiberar">Valor (R$)</label>

          <input type="text"
                 class="form-control"
                 id="valorALiberar"
                 v-model="atividade.valorLiberado"
                 data-vv-name="valorALiberar"
                 data-vv-as="valor"
                 v-mascara="'moeda'"
                 v-validate="'required|not_zero'"
                 disabled>

          <p class="text-danger" v-show="errors.has('valorALiberar')">{{ errors.first('valorALiberar') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('analise')}">
          <label class="control-label" for="analise">Análise</label>

          <textarea class="form-control"
                    id="analise"
                    v-model="atividade.analise"
                    data-vv-name="analise"
                    data-vv-as="análise"
                    :disabled="desabilitarAnalise(atividade.analise)"
                    v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('analise')">{{ errors.first('analise') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa-atividades/componentes/compartilhado/FormDadosCadastrais.vue